@if (!dismissed) {
    <div [@fadeInDownOnEnter] [@fadeOutUpOnLeave]>
        <div class="alert alert-sm" [ngClass]="['alert-' + type, customClass]" [ngClass]="{ 'alert-sm': small }">
            @if (dismissible) {
                <button type="button" class="close" (click)="close()">
                    <span>&times;</span>
                </button>
            }
            <span class="vismaicon vismaicon-filled" [ngClass]="'vismaicon-' + type"></span>
            <span [innerHTML]="text | translate"></span>
        </div>
    </div>
}
